// Typelizer digest 8582309d70d005caa90ea9906fe4b3b5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/overview/month_end_hand_over */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/overview/month_end_hand_over', {}, options),
    method: 'post',
  }),
}
